export default {
    serverError: 500,
    notfoundError: 404,
    unauthorizedError: 401,
    forbiddenError: 403
};
